(() => {
  'use strict';
  if (window.OmnisendCapture) return;
  // Theme signup forms post to Shopify, which syncs them to Omnisend as subscribed (with tags) within an hour.
  // This identifies the visitor to Omnisend straight away so browse and cart automations pick them up,
  // and only after the signup succeeded and the visitor allowed marketing cookies.
  const PENDING = 'omnisend:pending-signup';
  const store = (key, value) => {
    try {
      if (value === undefined) return sessionStorage.getItem(key);
      if (value === null) sessionStorage.removeItem(key); else sessionStorage.setItem(key, value);
    } catch (error) { /* storage blocked */ }
    return null;
  };

  function withConsent(callback) {
    const check = () => {
      const privacy = window.Shopify && window.Shopify.customerPrivacy;
      try { if (privacy && privacy.marketingAllowed()) callback(); } catch (error) { /* consent API unavailable */ }
    };
    if (window.Shopify && window.Shopify.customerPrivacy) check();
    else if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], error => { if (!error) check(); });
    }
  }

  // The Omnisend app embed loads its launcher asynchronously, so wait briefly for identifyContact.
  function withOmnisend(callback, tries = 20) {
    const omnisend = window.omnisend;
    if (omnisend && typeof omnisend.identifyContact === 'function') return callback(omnisend);
    if (tries > 0) setTimeout(() => withOmnisend(callback, tries - 1), 500);
  }

  function send(email, event) {
    email = String(email || '').trim();
    store(PENDING, null);
    if (!email) return;
    withConsent(() => withOmnisend(omnisend => {
      omnisend.identifyContact({ email });
      if (event && event.name) omnisend.push(['track', event.name, { ...(event.properties || {}) }]);
    }));
  }

  // Forms that reload the page: remember the email on submit, send it once Shopify confirms the signup.
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!form || !form.querySelector || !form.querySelector('[data-omnisend-capture]')) return;
    const email = form.querySelector('input[type="email"]');
    if (email && email.value) store(PENDING, email.value);
  });

  function flush() {
    const pending = store(PENDING);
    if (pending && document.querySelector('[data-omnisend-posted]')) send(pending);
  }

  window.OmnisendCapture = { send };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', flush);
  else flush();
})();
